import LassoModal from "../../../components/LassoModal";
import { Typography } from "@mui/material";


const SubRecipientsErrorModal = ({ error, open, setOpen }: any) => {


    return (
        <LassoModal open={open} onClose={() => setOpen(false)}>
            <Typography textAlign="center">
                   Validation Failed
            </Typography>
            {error.map((error: string, index: number) => {
                return (
                    <Typography key={`error-${index}`} textAlign="center">
                        {index + 1}: {error}
                    </Typography>
                )
            } )}
        </LassoModal>
    )

}

export default SubRecipientsErrorModal